import { useAuthentication } from '@autone/auth';
import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';

import { type ModuleName } from '../types';
import { Analytics } from '../utils';
import { MODULE_ENTERED } from '../utils/legacy-analytics/eventTypes';

import { useIntercom } from './useIntercom';

const useAppSettings = (module: ModuleName) => {
  const { user } = useAuthentication();
  const { userId, name, email } = user;

  const VITE_INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;
  const { handleIntercomBoot } = useIntercom(VITE_INTERCOM_APP_ID, user);

  useEffect(() => {
    handleIntercomBoot();

    if (import.meta.env.MODE !== 'development') {
      Sentry.setUser({ email, name, userId, id: userId });

      setTimeout(
        () =>
          window.Fullview?.identify(
            userId!, // OR anything unique in your organisation
            {
              name: name!,
              email,
            },
          ),
        2000,
      );

      Analytics.track(MODULE_ENTERED, {
        module,
      });
    }
  }, [user]);

  return {};
};

export default useAppSettings;
